import {FC} from 'react'
import {Outlet} from 'react-router-dom'

import {LegalFooter} from './legal-footer'
import {useLegalLang} from './use-legal-lang'

/** Pages that sit outside the venue Layout (no PreFooter there) still end with the legal footer. */
export const StandaloneLayout: FC<{compact?: boolean}> = ({compact = false}) => {
  const lang = useLegalLang()
  return (
    <>
      <Outlet />
      <LegalFooter
        lang={lang}
        compact={compact}
      />
    </>
  )
}
